import PropTypes from 'prop-types';
import { Card } from '@utilities';
import { getTileIcon } from '../../utilities/helpers';
import styles from './_index.module.scss';

const InteractiveTile = ({ onClick, route }) => {
  const { description, id, name } = route;
  const tileIcons = getTileIcon({ narrativeId: id });

  return (
    <Card
      as="button"
      className={styles['interactive-tile']}
      elevation={1}
      onClick={() => {
        onClick(route);
      }}
    >
      <div className={styles['interactive-tile-icon-wrapper']}>
        <span className={styles['interactive-tile-default-icon']}>{tileIcons.icon}</span>
        <span className={styles['interactive-tile-hover-icon']}>{tileIcons.filledIcon}</span>
      </div>
      <h3 className={styles['tile-title']}>{name}</h3>
      <p className={styles['tile-description']}>{description}</p>
    </Card>
  );
};

InteractiveTile.propTypes = {
  onClick: PropTypes.func.isRequired,
  route: PropTypes.object.isRequired,
};

export default InteractiveTile;
